import { adjustColor } from '@maxpreps/shared/functions/primitiveHelpers/colorHelpers';
import styled from 'styled-components';
import { useIsScreenSize } from '../../hooks/useIsScreenSize';
import { COLOR } from '../../styles/colors';
import { SITE_NAV_BREAK_POINT } from '../SiteNav/SiteNavUtils';
import NetworkLinksList from './NetworkLinksList';
import SocialLinksList, { StyledSocialLinksList } from './SocialLinksList';

const StyledNetworkBar = styled.div<{ $isVisible: boolean }>`
  display: ${({ $isVisible }) => ($isVisible ? 'flex' : 'none')};
  align-items: center;
  justify-content: space-between;

  height: 30px;
  padding: 4px;

  background-color: ${({ theme }) =>
    theme.colors.nav.isSiteNavDark
      ? adjustColor(theme.colors.nav.headerDark, -30)
      : theme.colors.nav.headerDark};

  color: ${COLOR.white};

  ${StyledSocialLinksList} a {
    background-color: ${({ theme }) =>
      theme.colors.nav.isSiteNavDark
        ? theme.colors.nav.headerDark
        : theme.colors.nav.header};
    &:hover {
      opacity: 0.9;
    }
  }
`;

const NetworkBar: React.FC = () => {
  const isDesktop = useIsScreenSize(SITE_NAV_BREAK_POINT);
  return (
    <StyledNetworkBar $isVisible={isDesktop}>
      <NetworkLinksList />
      <SocialLinksList />
    </StyledNetworkBar>
  );
};

export default NetworkBar;
